var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center",staticStyle:{"height":"80svh"}},[_c('v-progress-circular',{staticClass:"mx-auto",attrs:{"indeterminate":"","color":"#1976D2","size":32}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }